(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daily-delivery-target"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('varnut-daily-target')) {
  customElements.define('varnut-daily-target', class extends HTMLElement {
    static dayIndex(date, timeZone) {
      let parts;
      try { parts = new Intl.DateTimeFormat('en-US', {timeZone, year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date); }
      catch (_) { parts = new Intl.DateTimeFormat('en-US', {timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date); }
      const value = type => Number(parts.find(p => p.type === type).value);
      return Math.floor(Date.UTC(value('year'),value('month')-1,value('day')) / 86400000);
    }
    static shuffledRange(minimum, maximum, seed) {
      const integer = (value, fallback) => Number.isFinite(Number(value)) && String(value).trim() !== '' ? Math.floor(Number(value)) : fallback;
      let low = Math.max(0,Math.min(10000,integer(minimum,180)));
      let high = Math.max(0,Math.min(10000,integer(maximum,400)));
      if (low > high) [low,high] = [high,low];
      const values = Array.from({length:high-low+1},(_,i)=>low+i);
      let state = 2166136261;
      for (const char of String(seed)) state = Math.imul(state ^ char.charCodeAt(0),16777619) >>> 0;
      const random = () => {
        state = (state + 0x6D2B79F5) >>> 0;
        let t = state;
        t = Math.imul(t ^ (t >>> 15),t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7),t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
      };
      for (let i=values.length-1;i>0;i--) {
        const j=Math.floor(random()*(i+1));
        [values[i],values[j]]=[values[j],values[i]];
      }
      return values;
    }
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.start());
    }
    start() {
      if (this.events) return;
      this.box = this.querySelector('[data-target-boxes]');
      this.egg = this.querySelector('[data-target-eggs]');
      this.accessible = this.querySelector('[data-target-accessible]');
      if (!this.box || !this.accessible) return;
      this.events = new AbortController();
      this.sequence = this.constructor.shuffledRange(this.dataset.min,this.dataset.max,this.dataset.seed || 'pune-target');
      this.perBox = Math.max(1,Math.min(10000,Math.floor(Number(this.dataset.perBox)) || 15));
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-IN');
      this.day = null;
      this.visible = false;
      this.refresh();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry=>entry.isIntersecting)) {
            this.visible=true;
            this.animate();
            this.observer.disconnect();
          }
        },{threshold:0.15});
        this.observer.observe(this);
      } else {this.visible=true;this.animate();}
      // Recompute on a new local calendar day, including when a tab is left open.
      this.timer = setInterval(()=>this.refresh(),30000);
      document.addEventListener('visibilitychange',()=>{if (!document.hidden) this.refresh();},{signal:this.events.signal});
    }
    refresh(date=new Date()) {
      const day=this.constructor.dayIndex(date,this.dataset.timeZone || 'Asia/Kolkata');
      if(day===this.day) return;
      this.day=day;
      this.target=this.sequence[((day%this.sequence.length)+this.sequence.length)%this.sequence.length];
      const suffix=this.dataset.suffix || '';
      const boxes=`${this.format.format(this.target)}${suffix} ${this.dataset.boxLabel || ''}`;
      const eggs=`${this.format.format(this.target*this.perBox)}${suffix} ${this.dataset.eggLabel || ''}`;
      this.accessible.textContent=this.egg ? `${boxes}; ${eggs}` : boxes;
      this.paint(this.target);
      if(this.visible) this.animate();
    }
    paint(boxes) {
      this.box.textContent=this.format.format(boxes);
      if(this.egg) this.egg.textContent=this.format.format(boxes*this.perBox);
    }
    animate() {
      cancelAnimationFrame(this.animation);
      if(this.dataset.animate!=='true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches){this.paint(this.target);return;}
      const duration=Math.max(200,Math.min(4000,Number(this.dataset.duration)||1400));
      const start=performance.now();
      const tick=now=>{
        const progress=Math.min(1,Math.max(0,(now-start)/duration));
        this.paint(Math.round(this.target*(1-Math.pow(1-progress,3))));
        if(progress<1)this.animation=requestAnimationFrame(tick);
      };
      this.animation=requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.animation);
      clearInterval(this.timer);
      this.observer?.disconnect();
      this.events?.abort();
      this.events=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  if (!window.varnutPolicyPopupsReady) {
    window.varnutPolicyPopupsReady = true;

    document.addEventListener('click', function(event) {
      if (!(event.target instanceof Element)) return;

      const opener = event.target.closest('[data-vn-open]');

      if (opener) {
        const dialog = document.getElementById(
          opener.getAttribute('data-vn-open')
        );

        if (dialog instanceof HTMLDialogElement && !dialog.open) {
          dialog.showModal();
        }

        return;
      }

      const closeButton = event.target.closest('[data-vn-close]');

      if (closeButton) {
        const dialog = closeButton.closest('dialog');

        if (dialog instanceof HTMLDialogElement) {
          dialog.close();
        }

        return;
      }

      if (event.target.matches('dialog.vn-policy')) {
        const dialog = event.target;
        const bounds = dialog.getBoundingClientRect();

        const outside =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;

        if (outside) dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
